import { Controller } from "@hotwired/stimulus"

export default class FlashController extends Controller {
  connect() {
    const isBackForward = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (isBackForward) return;

    const message = this.element.dataset.flashMessage
    const type = this.element.dataset.flashType || "success"

    if (!message) return

    const selectedLanguage = globalThis.localStorage.getItem('selected_lang') || 'en'
    const needsTranslation = selectedLanguage !== 'en'
    if (needsTranslation) {
      this.showPendingTranslation(message, type)
      return
    }

    this.showAlert(message, type).then(() => {
      this.element.remove()
    })
  }

  showAlert(message, type, { loading = false } = {}) {
    return Swal.fire({
      customClass: {
        popup: "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      animation: false,
      html: message,
      icon: type,
      showCloseButton: !loading,
      buttonsStyling: false,
      showConfirmButton: false,
      timer: loading ? undefined : 3000,
      allowEscapeKey: !loading,
      allowOutsideClick: !loading
    })
  }

  showPendingTranslation(message, type) {
    const source = document.createElement('div')
    source.innerHTML = message
    const sourceText = source.textContent.trim()
    const alertPromise = this.showAlert(
      `<div class="flash-message-content">${message}</div>` +
      '<div class="flash-message-skeleton" aria-hidden="true"><span></span><span></span></div>',
      type,
      { loading: true }
    )
    const htmlContainer = Swal.getHtmlContainer()

    const revealTranslatedMessage = () => {
      const content = htmlContainer?.querySelector('.flash-message-content')
      const translatedText = content?.textContent.trim()

      if (!translatedText || translatedText === sourceText) return

      this.translationObserver?.disconnect()
      this.translationObserver = null
      globalThis.clearTimeout(this.translationFallback)
      content.setAttribute('translate', 'no')
      content.classList.add(
        'notranslate',
        'flash-message-content--translated'
      )
      htmlContainer.querySelector('.flash-message-skeleton')?.remove()

      const closeButton = Swal.getCloseButton()
      if (closeButton) closeButton.style.display = 'flex'

      this.translationTimeout = globalThis.setTimeout(() => Swal.close(), 10000)
    }

    this.translationObserver = new MutationObserver(revealTranslatedMessage)
    this.translationObserver.observe(htmlContainer, {
      subtree: true,
      childList: true,
      characterData: true
    })
    revealTranslatedMessage()

    this.translationFallback = globalThis.setTimeout(() => Swal.close(), 30000)

    alertPromise.then(() => {
      this.cleanupTranslationWait()
      this.element.remove()
    })
  }

  disconnect() {
    this.cleanupTranslationWait()
  }

  cleanupTranslationWait() {
    this.translationObserver?.disconnect()
    this.translationObserver = null
    globalThis.clearTimeout(this.translationTimeout)
    globalThis.clearTimeout(this.translationFallback)
  }
}
